module.exports = __webpack_public_path__ + "img/admin_dashboard.9b0f178f.svg";